/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

import React, { Component } from "react";
import "./styles/css/terms-of-service.css";
import {
  Button,
  Segment,
  Form,
  Input,
  Header,
  Checkbox,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import API from "../utility/API";
import EmailImage from "../Images/email-32.svg";
import { getWlBackGroundColor, getWhiteLabelCustomerName } from "../util";
import { Link } from "react-router-dom";

class Verification extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      mailSent: false,
      message: "",
      errorMessage: false,
      email: "",
    };
  }

  componentWillMount() {
    this.setState({ isLoading: true, email: this.props.location.state?.email });
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 2000);
  }

  handleChange = (e, { name, value }) =>
    this.setState({ [name]: value }, () => console.log(this.state));

  handleSubmit = () => {
    API.emailVerification(this.state.email)
      .then((res) => {
        this.setState({ isLoading: false });
        if (res.status === 200) {
          this.setState({
            mailSent: true,
            message:
              "A link has been sent to your mail box. Please check and complete your registration.",
          });
        } else {
          this.setState({
            errorMessage: true,
            message: "Unable to send mail.",
          });
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });
        console.error("CHECK ERROR: ", err);
      });
  };

  render() {
    const { isLoading, mailSent, message, errorMessage } = this.state;
    
    return (
      <Segment padded="very" className="tos-form" style={{ width: "500px" }}>
        {isLoading && (
          <Dimmer active inverted>
            <Loader size="medium">Loading</Loader>
          </Dimmer>
        )}
        {!isLoading && (
          <React.Fragment>
            <center>
              <img src={EmailImage} className="email-image" alt="email-image" />
              <Header className="tos-title" as="h1">
                Requested user have not completed the registration process
              </Header>
              <p className="tos-title">
                click below to complete your registration.
              </p>
              {/* {mailSent && <h4 style={{ color: "green" }}>{message}</h4>} */}
            </center>
            {/* --------- Resend verification link button ---------- */}
            {!mailSent ? (
              <center className="resend-button">
                <Button
                  disabled={mailSent}
                  onClick={this.handleSubmit}
                  type="submit"
                  className="tosSubmit"
                >
                  RESEND VERIFCATION LINK
                </Button>
              </center>
            ) : (
              <h4 style={{ color: "green", textAlign: "center" }}>{message}</h4>
            )}
            {errorMessage && <h4 style={{ color: "red" }}>{message}</h4>}
            <br />
            <br />
            <br />

            <center>
              <Link to="/" className="forgotLogin">
                {" "}
                Back to Login
              </Link>
            </center>
          </React.Fragment>
        )}
      </Segment>
    );
  }
}

export default Verification;
